import { AppData } from "@lightningjs/sdk"
import { AppSetup } from "../app-setup"
import { Logger } from "../logger"
import { Helper } from "../helper"

/**
 * @description AdManagerContext is a Class instance will be created and passed
 * as the second parameter (Ad request User contex of ima adk.) to  adsLoader.requestMethod.
 * @param  {CuePoint} cuePoint CuePoint reference Object
 * @param  {String} adType Ad type 'preroll' or 'midroll
 * @param  {Object} providers Ad providers List of objects
 * @param  {Number} podIndx Ad position index in current ad pod.
 * @param  {Number} cuePointTime Ad break time
 * @param  {AdsLoader} adsLoader Ima AdsLoader reference
 * @param  {Object} vodInfo current playing video node
 * @param  {string} guid transaction id
 */
class AdManagerContext {
    cuePoint:any
    adType:any
    providers:any
    podIndx:any
    cuePointTime:any
    adsManager:any
    adsLoader:any
    adHandler:any
    isAdAvailable:any
    waterfallIndx:any
    vodInfo:any
    guid:any
    breakPointPos:any
    timeStamp:any
    startAdInitiated:any
    adDetails:any
    trackers:any
    dedupeId:any
    isPodded:boolean;
    totalReceivedPoddedAds = -1;
    adPodDetailStatus = [];//{adDetails:null,status:null}
    _adTagUrl:any
    

    constructor(cuePoint:any, adType:any, providers:any, podIndx:any, cuePointTime:any, adsLoader:any, vodInfo:any, guid:any, breakPointPos:any, timestamp:any, adHandler:any, isPodded: boolean) {
        this.cuePoint = cuePoint;
        this.adType = adType;
        this.providers = providers;
        this.podIndx = podIndx;
        this.cuePointTime = cuePointTime;
        this.adsManager = null;
        this.adsLoader = adsLoader;
        this.adHandler = adHandler;
        this.isAdAvailable = false;
        this.waterfallIndx = 0;
        this.vodInfo = vodInfo;
        this.guid = guid;
        this.breakPointPos = breakPointPos;
        this.timeStamp = timestamp;
        this.startAdInitiated = false;

        this.adDetails = null;
        this.isPodded = isPodded;


        this.trackers = {
            requested: [],
            response: [],
            started: [],
            error: [],
            complete: [],
            firstQuartile:[],
            midpoint:[],
            thirdQuartile:[]
        }
        if(isPodded) {
            for(let i=0;i<guid.length;i++) {
                this.adPodDetailStatus.push({adDetails:null,status:null});
            }
        }
    }

    /**
     * @description When the adsManagerLoaded events fires the adsmanager reference is set to the cue point context.
     * @param  {AdsManager} adsManager
     */
    addAdsManager = (adsManager:any) => {
        this.adsManager = adsManager;

        var events = [
            google.ima.AdEvent.Type.LOADED,
            google.ima.AdEvent.Type.IMPRESSION,
            google.ima.AdEvent.Type.STARTED,
            google.ima.AdEvent.Type.FIRST_QUARTILE,
            google.ima.AdEvent.Type.MIDPOINT,
            google.ima.AdEvent.Type.THIRD_QUARTILE,
            google.ima.AdEvent.Type.COMPLETE,
            google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
            google.ima.AdEvent.Type.PAUSED,
            google.ima.AdEvent.Type.RESUMED,
            google.ima.AdEvent.Type.AD_PROGRESS,
            google.ima.AdEvent.Type.AD_BUFFERING,
            google.ima.AdEvent.Type.CLICK,
            google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
            google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
            google.ima.AdErrorEvent.Type.AD_ERROR,
            google.ima.AdEvent.LOG
        ];

        for (var index = 0; index < events.length; index++) {
            adsManager.addEventListener(
                events[index],
                this.onAdEvent.bind(this));
        }
    }

    /**
     * @description Destroys the adsManager reference.
     */
     startAd = () => {
         this.adsManager.start();
         this.startAdInitiated = true;
     }
    /**
     * @description Destroys the adsManager reference.
     */
    stopAd = () => {
        if(!this.isPodded) {        
            var errorCode = 402;
            var errorTracker = this.getErrorTracker(
                this.adType,
                this.providers[this.waterfallIndx],
                this.vodInfo,
                this.guid,
                errorCode
            );
            this.trackers.error.push(errorTracker);
        }
        //this.hitTrackers('error')
        //this.adsManager.dispatchEvent(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED)
        this.adsManager.stop();
        //this.onAdEvent(google.ima.AdEvent.CONTENT_RESUME_REQUESTED);

    }

    pause = () => {
        if (this.adsManager) {
            this.adsManager.pause();
        }
    }

    resume = () => {
        if (this.adsManager) {
            this.adsManager.resume();
        }
    }

    /**
     * @description Destroys the adsManager reference.
     */
    destroyAdsManager = () => {
        if (this.adsManager) {
            this.adsManager.destroy();
        }
    }

    /**
     * @description Initiate the adsRequest passes the self reference to the ads loader.
     */
    requestAds = () => {
        const { platform, appConfig, appState } = AppData as AppSetup
        var adsRequest = new google.ima.AdsRequest();
        var adTagUrl = ""
        if(this.providers && this.providers[this.waterfallIndx] && this.providers[this.waterfallIndx].url){
            adTagUrl = this.providers[this.waterfallIndx].url;
        }
        var testInfo = appConfig?.testInfo;
        if (testInfo.testAdMode) {
            if (testInfo.testAdsIds !== null) {
                var priotiryIndex = testInfo.testAdsIds[this.podIndx].split('-');
                var linkId = parseInt(priotiryIndex[this.waterfallIndx]);
                var url = testInfo.testAdsIdsUrl[linkId];
                if (url !== undefined && url !== "") {
                    adTagUrl = url;
                }
            } else {
                adTagUrl = testInfo.testYumeUrl;
            }
        }
        if(appConfig?.testAdTag) {
            adTagUrl = 'https://qa.adtags.ifood.tv/safeads?lineitemid=921&FT_NO_OF_SLOTS=[FT_NO_OF_SLOTS]&FT_PREFETCH_REQUEST=[FT_PREFETCH_REQUEST]&FT_BUNDLE_ID=[FT_BUNDLE_ID]&FT_TIMESTAMP=[FT_TIMESTAMP]&FT_CONTEXT=[FT_CONTEXT]&FT_CONTENT_LENGTH=[FT_CONTENT_LENGTH]&FT_AD_BREAK_POSITION=[FT_AD_BREAK_POSITION]&FT_DEVICE_MAKE=[FT_DEVICE_MAKE]&FT_TRACKING_ENABLED=[FT_TRACKING_ENABLED]&FT_APP_VERSION=[FT_APP_VERSION]&FT_DEVICE_LANGUAGE=[FT_DEVICE_LANGUAGE]&FT_DEVICE_MODEL=[FT_DEVICE_MODEL]&FT_USER_AGENT=[FT_USER_AGENT]&FT_APP_NAME=[FT_APP_NAME]&FT_TRACKING_ID=[FT_TRACKING_ID]&FT_PRIMARY_GENRE=[FT_PRIMARY_GENRE]&FT_CONTENT_RATING=[FT_CONTENT_RATING]&FT_PUBLISHER=[FT_PUBLISHER]&FT_APP_STORE_URL=[FT_APP_STORE_URL]&FT_APP_STORE_ID=[FT_APP_STORE_ID]&FT_CONTENT_ID=[FT_CONTENT_ID]&FT_DEDUPE_ID=[FT_DEDUPE_ID]&FT_CONTENT_GENRE=[FT_CONTENT_GENRE]';
            adTagUrl = "https://testing2.freeawesometv.com/samsung/config/testad/ad-video.xml?";
        }

        if(adTagUrl){
            if(this.adHandler.dedupeId){
                if (adTagUrl.indexOf('[FT_DEDUPE_ID]') > -1) {
                    adTagUrl = adTagUrl.split('[FT_DEDUPE_ID]').join(this.adHandler.dedupeId);                
                }                
            }
            adTagUrl = this.adHandler.replaceMacros(adTagUrl, this.adType, this.breakPointPos, (this.podIndx + 1));
        }
        if(appConfig.enableIMAAdPodding && appConfig.enableFusePrefetch){
            //if (context == 'preroll') {
            var FT_PREFETCH_REQUEST = 1;
            var PREFETCH_SECOND_REQUEST = true;
            if(this.adType=='preroll') {
                PREFETCH_SECOND_REQUEST = false;
                FT_PREFETCH_REQUEST = 0;
            }           
            adTagUrl = adTagUrl + `&PREFETCH_SECOND_REQUEST=${PREFETCH_SECOND_REQUEST}&FT_PREFETCH_REQUEST=${FT_PREFETCH_REQUEST}`;
            Helper.logFuseEvent(adTagUrl,'FUSE_PREFETCH_REQUEST');
            Logger.processUserAction('FUSE_PREFETCH','FUSE_PREFETCH_REQUEST');                
        }
        this.dedupeId = platform?.getDeviceId() + this.timeStamp + this.vodInfo.node_id + this.breakPointPos + this.waterfallIndx;
        //adTagUrl = 'https://pbs.getpublica.com/v1/inventory_route?inventory_route_id=214&app_bundle=fawesome.tv&format=vast&cb=1697010673710&ip=&ipv6=&ua=Mozilla/5.0%20(Linux;%20Android%206.0;%20Nexus%205%20Build/MRA58N)%20AppleWebKit/537.36%20(KHTML,%20like%20Gecko)%20Chrome/117.0.0.0%20Mobile%20Safari/537.36&is_lat=0&app_domain=comcast.fawesome.tv&app_name=fawesome.tv&app_version=AX061AEI&content_cat=IAB1-5&content_episode=&content_genre=Action,Drama&content_language=en-US&content_length=5312&content_producer=EncoreLicensed&content_rating=R&content_series=&content_title=I%20Am%20That%20Man&device_language=en-US&us_privacy=1YNN&max_bitrate=10000&content_id=10483643&slot_count=1&max_ad_duration=32&custom_6=2&custom_7=1697010673710&nonce=-1&iris_content_id=10483643&url=fawesome.tv&nonce=-1'        
        //adTagUrl = 'https://testing2.freeawesometv.com/samsung/config/testad/spotx-test-ad.xml';//'https://ssp.lkqd.net/ad?pid=498&sid=951258&output=vast&execution=instream&placement=preroll&playinit=auto&volume=100&width=%5BPLAYER_WIDTH%5D&height=%5BPLAYER_HEIGHT%5D&dnt=FIRETV_ADS_TRACKING_ENABLED&gdpr=0&gdprcs=&ip=%5BIP_ADDRESS%5D&ua=FIRETV_ADS_USER_AGENT&appname=filmrise&bundleid=%5BBUNDLE_ID%5D&appstoreurl=%5BAPP_STORE_URL%5D&appversion=%5BAPP_VERSION%5D&aid=FIRETV_ADS_TRACKING_ID&contentlength=%5BCONTENT_LENGTH%5D&rnd=%5BCACHE_BUSTER%5D&contentid=%5BCONTENT_ID%5D&&contenttitle=%5BCONTENT_TITLE%5D';
        //adTagUrl = 'https://testing2.freeawesometv.com/samsung/config/testad/ad-poded-all-filled-400.xml';//'https://ssp.lkqd.net/ad?pid=498&sid=951258&output=vast&execution=instream&placement=preroll&playinit=auto&volume=100&width=%5BPLAYER_WIDTH%5D&height=%5BPLAYER_HEIGHT%5D&dnt=FIRETV_ADS_TRACKING_ENABLED&gdpr=0&gdprcs=&ip=%5BIP_ADDRESS%5D&ua=FIRETV_ADS_USER_AGENT&appname=filmrise&bundleid=%5BBUNDLE_ID%5D&appstoreurl=%5BAPP_STORE_URL%5D&appversion=%5BAPP_VERSION%5D&aid=FIRETV_ADS_TRACKING_ID&contentlength=%5BCONTENT_LENGTH%5D&rnd=%5BCACHE_BUSTER%5D&contentid=%5BCONTENT_ID%5D&&contenttitle=%5BCONTENT_TITLE%5D';
        this._adTagUrl = adTagUrl;
        //adTagUrl = "https://testing2.freeawesometv.com/samsung/config/testad/ad-pod.xml";
        adsRequest.adTagUrl = adTagUrl;
        adsRequest.setAdWillAutoPlay(true);
        adsRequest.setAdWillPlayMuted(false);
        this.adsLoader.requestAds(adsRequest, this);
        var requestTrackerCount = 1;
        if(this.isPodded){
            requestTrackerCount = this.guid.length;
        }
        for(var i = 0; i < requestTrackerCount; i++) {
            var guid = this.guid;
            if(this.isPodded) {
                guid = this.guid[i];
            }
            var requestTracker = this.getRequestTracker(
                this.adType,
                this.providers[this.waterfallIndx],
                this.vodInfo,
                guid
            );
            this.trackers.requested.push(requestTracker);
        }
        
        this.hitTrackers('requested');
        Logger.printLog('data', 'Requesting Ad at: ' + this.cuePoint + ", podIndx: " + this.podIndx,'');
    }

    /**
     * @description Destroys the AdManagerContext reference.
     */
    destroy = () => {
        this.destroyAdsManager();
        this.adsManager = null;
        this.adsLoader = null;
        this.cuePoint = null;
        this.providers = null;
        this.vodInfo = null;
        this.adHandler = null;
    }

    /**
     * @description Dispatches the Ads events to the parent handler with the current podIndex.
     * @param  {AdEvent} event
     */
    onAdEvent = (event:any) => {        
        if(event.type!="adProgress"){
            Logger.printLog('data', 'IMA onAdEvent ' + event.type,'');
            //console.log('AdManagerContext : ', event.type, ' --- ', Math.random());
        }
        if(event.type =='start'){
            this.cuePoint.clearAdStartIntv();
        }
        if (event.type == google.ima.AdEvent.Type.LOADED) {
            this.isAdAvailable = true;
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }            
            this.setAdDetails(currAd);
            let guid = this.guid;
            if(this.isPodded) {                
                var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                guid = this.guid[adPosition];
                if(this.totalReceivedPoddedAds == -1) {
                    this.totalReceivedPoddedAds = currAd.getAdPodInfo().getTotalAds();
                }
                if(this.adPodDetailStatus[adPosition]) {
                    this.adPodDetailStatus[adPosition].adDetails = this.adDetails;               
                    this.adPodDetailStatus[adPosition].status = "loaded";
                }                
            }
            const waterfallIndx = this.waterfallIndx || 0
            const provider = this.providers[waterfallIndx] || 'ima'            
            var responseTracker = this.getResponseTracker(
                this.adType,
                provider,
                this.vodInfo,
                guid,
                null
            );
            this.trackers.response.push(responseTracker);
            //this.hitTrackers('response');
        } else if (event.type == google.ima.AdErrorEvent.Type.AD_ERROR) {
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }
            let guid = this.guid;
            /*if(this.isPodded) {
                if(currAd && currAd.getAdPodInfo() && currAd.getAdPodInfo().getAdPosition()) {
                    var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                    guid = this.guid[adPosition];
                } else {
                    guid = "";
                }          
            }*/
            if(currAd) {
                this.setAdDetails(currAd);
            }
            this.isAdAvailable = true;
            if(!this.isPodded) {
                var errorCode = event.getError().getErrorCode();
                var errorTracker = this.getErrorTracker(
                    this.adType,
                    this.providers[this.waterfallIndx],
                    this.vodInfo,
                    guid,
                    errorCode
                );
                this.trackers.error.push(errorTracker);
            }
            
            
            var responseTracker = this.getResponseTracker(
                this.adType,
                this.providers[this.waterfallIndx],
                this.vodInfo,
                guid,
                null
            );
            this.trackers.response.push(responseTracker);
            if(!this.startAdInitiated) {
                //this.hitTrackers('response');
            }
        } else if (event.type == google.ima.AdEvent.Type.COMPLETE) {
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }
            let guid = this.guid;
            if(this.isPodded) {                
                var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                guid = this.guid[adPosition];
                if(this.adPodDetailStatus[adPosition]) {
                    this.adPodDetailStatus[adPosition].status = "complete";
                }
            }
            var completeTracker = this.getCompleteTracker(
                this.adType,
                this.providers[this.waterfallIndx],
                this.vodInfo,
                guid
            );
            this.trackers.complete.push(completeTracker);
        } else if (event.type == google.ima.AdEvent.Type.LOG) {
            var adData = event.getAdData();
            if (adData['adError']) {
                this.adsManager.discardAdBreak();
                return;
            }
        } else if (event.type == google.ima.AdEvent.Type.ALL_ADS_COMPLETED) {
            this.hitUnfilledPoddedAds();            
        } else if(event.type == 'firstQuartile'){            
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }
            var guid = this.guid;            
            if(this.isPodded) {                
                var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                guid = this.guid[adPosition];                
            }            
            var firstQuartileTracker = this.getFirstQuartileTracker(
            this.adType,
            this.providers[this.waterfallIndx],
            this.vodInfo,
            guid
            );
            // this.trackers.firstQuartile.push(firstQuartileTracker);
            // this.hitTrackers('firstQuartile');
        } else if(event.type == 'midpoint'){            
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }
            var guid = this.guid;            
            if(this.isPodded) {                
                var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                guid = this.guid[adPosition];                
            }            
            var midpointTracker = this.getMidpointTracker(
            this.adType,
            this.providers[this.waterfallIndx],
            this.vodInfo,
            guid
            );
            // this.trackers.midpoint.push(midpointTracker);
            // this.hitTrackers('midpoint');
        } else if(event.type == 'thirdQuartile'){            
            var currAd = null;
            try {
                currAd = event.getAd();
            } catch (e) {

            }
            var guid = this.guid;            
            if(this.isPodded) {                
                var adPosition = currAd.getAdPodInfo().getAdPosition()-1;
                guid = this.guid[adPosition];                
            }            
            var thirdQuartileTracker = this.getThirdQuartileTracker(
            this.adType,
            this.providers[this.waterfallIndx],
            this.vodInfo,
            guid
            );
            // this.trackers.thirdQuartile.push(thirdQuartileTracker);
            // this.hitTrackers('thirdQuartile');
        } else if(event.type == 'contentPauseRequested'){
            const { appConfig } = AppData as AppSetup
            if(appConfig.enableIMAAdPodding && appConfig.enableFusePrefetch){
                this.adHandler.dedupeId = '';                        
                Helper.logFuseEvent(this._adTagUrl,'PREFETCH_VALID_RESPONSE',this.totalReceivedPoddedAds);
                Logger.processUserAction('FUSE_PREFETCH',`PREFETCH_VALID_RESPONSE_adCount_${this.totalReceivedPoddedAds}`);
            }
        }
        this.cuePoint.onAdEvent(event, this.podIndx);
    }

    /**
     * @description Dispatches the Ads events to the parent handler with the current podIndex.
     * @param  {AdErrorEvent} event
     */
    onAdError = (event:any) => {        
        Logger.printLog('data', 'IMA onAdError ' + event.type,'');
        const {  appConfig } = AppData as AppSetup
        if(appConfig.enableIMAAdPodding && appConfig.enableFusePrefetch){                        
            Helper.logFuseEvent(this._adTagUrl,'PREFETCH_EMPTY_RESPONSE');
            Logger.processUserAction('FUSE_PREFETCH',`PREFETCH_EMPTY_RESPONSE`);
            this.adHandler.dedupeId = '';
        }
        if (event.type == google.ima.AdErrorEvent.Type.AD_ERROR) {
            var errorTrackerCount = 1;
            if(this.isPodded){
                errorTrackerCount = this.guid.length;
            }
            this.isAdAvailable = false;
            var errorCode = event.getError().getErrorCode();
            for(var i = 0; i < errorTrackerCount; i++) {
                var guid = this.guid;
                if(this.isPodded) {
                    guid = this.guid[i];
                }
                var errorTracker = this.getErrorTracker(
                    this.adType,
                    this.providers[this.waterfallIndx],
                    this.vodInfo,
                    guid,
                    errorCode
                );
                this.trackers.error.push(errorTracker);
            }
            
            var responseTracker = this.getResponseTracker(
                this.adType,
                this.providers[this.waterfallIndx],
                this.vodInfo,
                this.guid,
                errorCode
            );
            this.setAdDetails(null);
            this.trackers.response.push(responseTracker);
            //this.hitTrackers('response');
        }
        if (this.waterfallIndx < this.providers.length - 1) {
            this.hitTrackers('error');
            this.waterfallIndx++;
            this.destroyAdsManager();
            this.setAdDetails(null);
            this.isAdAvailable = false;
            this.requestAds();
        } else {
            this.cuePoint.onAdError(event, this.podIndx);
        }
    }

    /**
     * @description Sets the adDetails string
     * @param  { Object } currentAd
     */
    setAdDetails = (currentAd:any) => {
        var adDetails = '';
        try {
            adDetails += "title_" + encodeURIComponent(currentAd.getTitle());
            adDetails += "_adId_" + currentAd.getAdId()
            adDetails += "_creativeId_" + currentAd.getCreativeId()
            adDetails += "_creativeAdId_" + currentAd.getCreativeAdId();
            adDetails += "_creativeType_" + currentAd.getContentType();
            adDetails += "_creativeUrl_" + encodeURIComponent(currentAd.getMediaUrl());
            adDetails += "_bitrate_" + currentAd.getVastMediaBitrate()
        } catch (e) {
            adDetails = 'noAd';
        }
        this.adDetails = adDetails;        
    }


    /**
     * @description Generates request trackers url
     * @param  {String} adType
     * @param  {Array} adProvider
     * @param  {Object} vodInfo
     * @param  {String} guid
     */
    getRequestTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + false;
        jsonURL += '&adtitle=' + ''
        jsonURL += '&event=adSentToIma';
        return jsonURL;
    }    

    getResponseTracker = (adType:any, adProvider:any, vodInfo:any, guid:any, error = null) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        if (!error) {
            jsonURL += '&adAvailable=' + this.isAdAvailable;
            jsonURL += '&adPlayed=' + false;
            jsonURL += '&adtitle=' + this.adDetails;
        } else {
            jsonURL += '&adAvailable=' + this.isAdAvailable;
            jsonURL += '&adPlayed=' + false;
            jsonURL += '&adtitle=' + 'invalid_' + error;
        }
        jsonURL += '&event=adReceivedFromIma';

        return jsonURL;
    }


    /**
     * @description Generates request trackers url
     * @param  {String} adType
     * @param  {Array} adProvider
     * @param  {Object} vodInfo
     * @param  {String} guid
     */
    getStartTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + true;
        jsonURL += '&adPlayed=' + false;
        jsonURL += '&event=start';
        return jsonURL;
    }

    /**
     * @description Generates error trackers url
     * @param  {String} adType
     * @param  {Array} adProvider
     * @param  {Object} vodInfo
     * @param  {String} guid
     * @param  {String} errorCode
     */
    getErrorTracker = (adType:any, adProvider:any, vodInfo:any, guid:any, errorCode:any,adDetails='noAd') => {        
        //let adDetails = 'noAd';
        // if(this.adDetails){
        //     adDetails = this.adDetails;
        // }        
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + false;
        jsonURL += '&adtitle=' + adDetails;
        jsonURL += '&event=ad_invalid_' + errorCode;
        return jsonURL;
    }

    /**
     * @description Generates error trackers url
     * @param  {String} adType
     * @param  {Array} adProvider
     * @param  {Object} vodInfo
     * @param  {String} guid
     */
    getCompleteTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + true;
        jsonURL += '&adtitle=' + this.adDetails;
        jsonURL += '&event=complete';
        return jsonURL;
    }

    getFirstQuartileTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + true;
        jsonURL += '&adtitle=' + this.adDetails;
        jsonURL += '&event=firstQuartile';
        return jsonURL;
    }
    
    getMidpointTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + true;
        jsonURL += '&adtitle=' + this.adDetails;
        jsonURL += '&event=midpoint';
        return jsonURL;
    }

    getThirdQuartileTracker = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const apiBaseUrl = appConfig?.logUrl
        var jsonURL = apiBaseUrl + '?q=adview';
        jsonURL += this.getCommonTrackerParams(adType, adProvider, vodInfo, guid);
        jsonURL += '&adAvailable=' + this.isAdAvailable;
        jsonURL += '&adPlayed=' + true;
        jsonURL += '&adtitle=' + this.adDetails;
        jsonURL += '&event=thirdQuartile';
        return jsonURL;
    }




    getCommonTrackerParams = (adType:any, adProvider:any, vodInfo:any, guid:any) => {
        const { appConfig, platform } = AppData as AppSetup;
        var jsonURL = ''
        jsonURL += '&auth-token=' + appConfig?.platform_id;
        jsonURL += '&appid=' + platform?.getDeviceId();
        jsonURL += '&version=' + appConfig?.apiVersion;
        jsonURL += '&apptype=' + Helper.getAppType();
        jsonURL += '&siteId=' + appConfig?.siteId;
        jsonURL += '&format=json';
        jsonURL += '&type=post';
        jsonURL += '&uid=' + vodInfo['uid'];
        jsonURL += '&id=' + vodInfo['node_id'];
        if(adProvider){
            jsonURL += '&adProvider=' + adProvider.name;
            jsonURL += '&priority=' + adProvider.priority;
        }
        jsonURL += '&adType=' + adType;
        if(adProvider){
            jsonURL += '&adProviderName=' + adProvider.provider;
        }
        jsonURL += '&transactionId=' + guid;
        jsonURL += '&isPreAdDetails=false';
        jsonURL += '&isAd=true';
        jsonURL += '&session_id=' + appConfig?.sessionId;
        if(adProvider){
            jsonURL += '&rowId=' + (adProvider.rowId || '');
        }

        return jsonURL;
    }

    /**
     * @description Hitting the tracker based on tracker types eg. error, complete.
     * @param  {string} trackerType
     */
    hitTrackers = (trackerType:any) => {
        var trackers = this.trackers[trackerType];

        if (!trackers) return;
        if (trackers.length == 0) return;

        while (trackers.length > 0) {
            var tracker = trackers.pop();
            var params = tracker.split('?')[1];
            Logger.requestLog(params);
        }
        // for (var i = 0; i < trackers.length; i++) {
        //     var tracker = trackers[i];
        //     var params = tracker.split('?')[1];
        //     logger.requestLog(params);
        // }

        this.trackers[trackerType] = [];
    }

    hitUnfilledPoddedAds = () => {
        if(this.isPodded) {            
            for(let i = 0; i<this.guid.length;i++) {
                let adDetails = this.adPodDetailStatus[i].adDetails;
                let status = this.adPodDetailStatus[i].status;
                if(status != "complete") {                    
                    let errorTracker = this.getErrorTracker(
                        this.adType,
                        this.providers[this.waterfallIndx],
                        this.vodInfo,
                        this.guid[i],
                        "InvalidAd"
                        //google.ima.AdError.ErrorCode.VIDEO_PLAY_ERROR
                    );
                    if(adDetails) {
                        this.isAdAvailable = true;
                        errorTracker = this.getErrorTracker(
                            this.adType,
                            this.providers[this.waterfallIndx],
                            this.vodInfo,
                            this.guid[i],
                            // "InvalidAd",
                            google.ima.AdError.ErrorCode.VIDEO_PLAY_ERROR,
                            adDetails
                        );
                    }                    
                    this.trackers.error.push(errorTracker);

                }                
            }
            this.hitTrackers('error');





            /*var noOfAds = this.guid.length;
            var unfilledAdsCount = noOfAds - this.totalReceivedPoddedAds;
            if(unfilledAdsCount > 0) {
                var startIndex = this.totalReceivedPoddedAds;
                var endIndex = noOfAds;                
                for(var i = startIndex; i<endIndex; i++) {
                    var errorTracker = this.getErrorTracker(
                        this.adType,
                        this.providers[this.waterfallIndx],
                        this.vodInfo,
                        this.guid[i],
                        "InvalidAd"
                    );
                    this.trackers.error.push(errorTracker);
                }
                this.hitTrackers('error');                
            }*/
        }
    }
    
}

export default AdManagerContext;
